import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { selectLogo } from 'core/utils';

// defaultTemplate already applies observer(), so this must not be wrapped again.
const WalmartConnectTemplate = ({
	t,
	viewStore: { loading, hasLoaded, hasWalmartChannels, walmartChannels, selectedChannelId, selectChannel, onConnect },
}) => {
	const logo_show = selectLogo();
	return (
		<main className="body--secondary">
			<section className="w--400--px align--h--center padd--top--med">
				<img className="w--280--px display--b align--h--center" src={logo_show} alt="Logo" />
				<div className="card card--med spc--top--med">
					<h3 className="spc--bottom--sml">{t('OAUTH.WALMART.CONNECT.TITLE')}</h3>

					{loading && (
						<div className="spinnercont spc--bottom--sml">
							<div className="spinner"></div>
						</div>
					)}

					{hasLoaded && !hasWalmartChannels && (
						<p className="spc--bottom--sml">{t('OAUTH.WALMART.CONNECT.NOCHANNELS')}</p>
					)}

					{hasLoaded && hasWalmartChannels && (
						<React.Fragment>
							<p className="spc--bottom--sml">{t('OAUTH.WALMART.CONNECT.DESCRIPTION')}</p>
							{walmartChannels.map(channel => (
								<label key={channel.id} className="display--b spc--bottom--tny">
									<input
										type="radio"
										name="walmartChannel"
										value={channel.id}
										checked={selectedChannelId === channel.id}
										onChange={() => selectChannel(channel.id)}
									/>
									<span className="spc--left--tny">{channel.name}</span>
								</label>
							))}
							<div className="group spc--top--med">
								<button type="button" className="btn btn--med btn--primary pull" onClick={onConnect} disabled={loading}>
									{t('OAUTH.WALMART.CONNECT.AUTHORIZE')}
								</button>
							</div>
						</React.Fragment>
					)}
				</div>
			</section>
		</main>
	);
};

export default defaultTemplate(WalmartConnectTemplate);
